// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Bmo9","choiceBoxes":"toolbarselects_choiceBoxes__1WEDm","simpleField":"toolbarselects_simpleField__vcVxM"};